import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_Message = _resolveComponent("Message")

  return (_openBlock(), _createBlock(_component_Message, {
    severity: "contrast",
    pt: {root: '', text: ''}
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode("Contrast Message")
    ])),
    _: 1 /* STABLE */,
    __: [0]
  }))
}